import React from 'react';
import { Chip } from '@material-ui/core';
import UserRole from '../constants/user-role';

interface IProps {
  role: string;
}

const UserRoleChip: React.FC<IProps> = ({ role }) => {
  let color: 'default' | 'primary' | 'secondary' = 'default';
  if (role === UserRole.manager) color = 'primary';
  if (role === UserRole.admin) color = 'secondary';

  return <Chip size="small" variant="outlined" label={role} color={color} />;
};

export default UserRoleChip;
